<template>
  <div class="focus-module">
    <div class="form-row">
      <div class="form-label">焦点标题：</div>
      <div class="form-content">
        <a-select v-model="value.focusTitleType" class="type-select" :options="typeOptions" />
        <a-input
          v-if="value.focusTitleType === 1"
          v-model="value.focusTitle"
          class="title-input"
          placeholder="请输入"
          allow-clear
        />
        <div v-else class="upload-wrap">
          <a-upload
            :action="uploadFileUrl"
            :accept="acceptTypes"
            :file-list="focusTitleFileList"
            :before-upload="beforeUploadImage"
            @change="info => onFocusImageChange('focusTitle', info)"
          >
            <a-button icon="upload">上传文件</a-button>
          </a-upload>
          <div class="upload-tip">支持扩展名：.png .jpg...；图片最佳尺寸：宽度不限 * 70px</div>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="form-label">焦点副标题：</div>
      <div class="form-content">
        <a-select v-model="value.focusSubTitleType" class="type-select" :options="typeOptions" />
        <a-input
          v-if="value.focusSubTitleType === 1"
          v-model="value.focusSubTitle"
          class="title-input"
          placeholder="请输入"
          allow-clear
        />
        <div v-else class="upload-wrap">
          <a-upload
            :action="uploadFileUrl"
            :accept="acceptTypes"
            :file-list="focusSubTitleFileList"
            :before-upload="beforeUploadImage"
            @change="info => onFocusImageChange('focusSubTitle', info)"
          >
            <a-button icon="upload">上传文件</a-button>
          </a-upload>
          <div class="upload-tip">支持扩展名：.png .jpg...；图片最佳尺寸：宽度不限 * 70px</div>
        </div>
      </div>
    </div>

    <div class="section-title">选择商品切换样式</div>
    <div class="style-grid">
      <div
        v-for="style in switchStyles"
        :key="style.value"
        class="style-item"
        :class="{ active: value.switchStyleType === style.value }"
        @click="value.switchStyleType = style.value"
      >
        <img class="style-preview-img" :src="style.image" :alt="style.label">
      </div>
    </div>

    <div class="section-title">添加Tab标签</div>
    <div class="tab-list">
      <div v-for="(tab, index) in value.tabs" :key="tab.id" class="tab-row">
        <a-input v-model="tab.tabName" class="tab-name-input" placeholder="标签名" allow-clear />
        <a-upload
          :action="uploadFileUrl"
          :accept="acceptTypes"
          :file-list="tab.selectedFileList"
          :before-upload="beforeUploadImage"
          @change="info => onTabImageChange(tab, 'selected', info)"
        >
          <a-button icon="upload">选中图片</a-button>
        </a-upload>
        <a-upload
          :action="uploadFileUrl"
          :accept="acceptTypes"
          :file-list="tab.unselectedFileList"
          :before-upload="beforeUploadImage"
          @change="info => onTabImageChange(tab, 'unselected', info)"
        >
          <a-button icon="upload">未选中图片</a-button>
        </a-upload>
        <a-icon
          type="minus-circle"
          class="tab-remove"
          @click="onRemoveTab(index)"
        />
      </div>
      <a-button class="tab-add-btn" type="dashed" icon="plus" block @click="onAddTab">
        添加
      </a-button>
    </div>

    <div class="product-bind-header">
      <div class="section-title">
        关联商品
        <span class="drag-tip">（拖拽左侧图标可调整排序）</span>
      </div>
      <div class="product-bind-actions">
        <a-select
          v-model="addProductTargetType"
          class="add-target-select"
          :options="addProductTargetOptions"
        />
        <a-button type="primary" icon="plus" @click="onAddProduct">新建</a-button>
        <a-button @click="onBatchAction">批量操作</a-button>
        <a-input-search
          v-model="productKeyword"
          placeholder="搜索"
          style="width: 200px"
          @search="onSearchProduct"
        />
      </div>
    </div>
    <a-table
      ref="productTable"
      row-key="proId"
      size="middle"
      :columns="productColumns"
      :data-source="filteredProductTableData"
      :pagination="productPagination"
      :row-selection="{ selectedRowKeys: selectedProductRowKeys, onChange: onProductSelectChange }"
      @change="onProductTableChange"
    >
      <template slot="drag" slot-scope="">
        <a-icon type="menu" class="drag-handle" title="拖拽排序" />
      </template>
      <template slot="action" slot-scope="text, record">
        <a @click="onRemoveProduct(record)">移除</a>
      </template>
    </a-table>

    <selected-product-dialog
      :show="showProductDialog"
      title="选择商品"
      :width="1100"
      :item-names="['search_proId', 'search_proName', 'search_proCatalog']"
      :query-params="selectedQueryParams"
      :request-promise="getModularProductPromise"
      :columns="getGoodsColumns(true)"
      row-key="proId"
      :custom-pagination="true"
      :row-selection="productDialogRowSelection"
      @close="showProductDialog = false"
    >
      <a-form-item slot="search_proId" label="商品ID" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proId" placeholder="请输入商品ID" allow-clear />
      </a-form-item>
      <a-form-item slot="search_proName" label="商品名称" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proName" placeholder="请输入商品名称" allow-clear />
      </a-form-item>
      <a-form-item slot="search_proCatalog" label="商品分类" v-bind="currentDialogLayout">
        <a-select
          v-model="selectedQueryParams.proCatalog"
          placeholder="请选择"
          allow-clear
          style="width: 100%"
        >
          <a-select-option
            v-for="item in proCatalogEnum"
            :key="item.value"
            :value="item.value"
          >
            {{ item.key }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <template slot="proCatalog" slot-scope="rowItem">
        {{ getProCatalogName(rowItem.record.proCatalog, proCatalogEnum) }}
      </template>
      <div slot="footer" class="product-select-footer">
        <a-button @click="showProductDialog = false">取消</a-button>
        <a-button type="primary" @click="onConfirmSelectProducts">确定</a-button>
      </div>
    </selected-product-dialog>

    <selected-product-dialog
      :show="showGroupDialog"
      title="选择商品分组"
      :width="1100"
      :col="2"
      :item-names="['search_groupName']"
      :query-params="selectedQueryGroupParams"
      :request-promise="getGroupRequest"
      :columns="groupSelectColumns"
      row-key="groupId"
      :custom-pagination="true"
      :row-selection="groupDialogRowSelection"
      @close="showGroupDialog = false"
    >
      <a-form-item slot="search_groupName" label="商品分组名称" v-bind="currentDialogLayout">
        <a-input
          v-model="selectedQueryGroupParams.groupName"
          placeholder="请输入商品分组名称"
          allow-clear
        />
      </a-form-item>
      <div slot="footer" class="product-select-footer">
        <a-button @click="showGroupDialog = false">取消</a-button>
        <a-button type="primary" :loading="groupProductLoading" @click="onConfirmSelectGroup">
          确定
        </a-button>
      </div>
    </selected-product-dialog>

    <a-modal
      title="批量修改Tab标签"
      :visible="showBatchTabDialog"
      :confirm-loading="false"
      destroy-on-close
      @ok="onConfirmBatchTab"
      @cancel="showBatchTabDialog = false"
    >
      <div class="batch-tab-form">
        <span class="batch-tab-label">Tab标签：</span>
        <a-select
          v-model="batchTabName"
          placeholder="请选择Tab标签"
          allow-clear
          style="width: 280px"
          :options="tabNameOptions"
        />
      </div>
      <div class="batch-tab-tip">已选 {{ selectedProductRowKeys.length }} 个商品</div>
    </a-modal>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog.vue'
import productMixins from '@/utils/mixins/productMixins'

const PRODUCT_COLUMNS = [
  {
    title: '',
    dataIndex: 'drag',
    width: 48,
    scopedSlots: { customRender: 'drag' }
  },
  { title: '商品ID', dataIndex: 'proId', width: 140 },
  { title: '商品标题', dataIndex: 'productName', ellipsis: true },
  { title: '状态', dataIndex: 'statusName', width: 100 },
  { title: 'Tab标签', dataIndex: 'tabName', width: 120 },
  {
    title: '操作',
    dataIndex: 'action',
    width: 100,
    scopedSlots: { customRender: 'action' }
  }
]

function createEmptyTab (name = '') {
  return {
    id: `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    tabName: name,
    sortNo: 1,
    tabImage: '',
    selectedImage: '',
    unChoiceTabImage: '',
    selectedFileList: [],
    unselectedFileList: [],
    products: []
  }
}

export default {
  name: 'ActivityFocusModule',
  components: {
    SelectedProductDialog
  },
  mixins: [productMixins],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      uploadFileUrl: this.getUploadFileUrl(),
      acceptTypes: '.png,.jpg,.jpeg',
      typeOptions: [
        { label: '文字', value: 1 },
        { label: '图片', value: 2 }
      ],
      switchStyles: [
        {
          value: 1,
          label: '商品切换样式1',
          image: 'https://imgbtest.woyoubooking.com/test/base/71513b8728164ed880be14f9bdf22df8.png '
        },
        {
          value: 2,
          label: '商品切换样式2',
          image: 'https://imgbtest.woyoubooking.com/test/base/533ab46c6a194824bb31619cd2e6048f.png'
        },
        {
          value: 3,
          label: '商品切换样式3',
          image: 'https://imgbtest.woyoubooking.com/test/base/aa551a27341047999a98982b46a94ba4.png'
        },
        {
          value: 4,
          label: '商品切换样式4',
          image: 'https://imgbtest.woyoubooking.com/test/base/297d222a3b334f8190376fdab29a683e.png'
        }
      ],
      focusTitleFileList: [],
      focusSubTitleFileList: [],
      productKeyword: '',
      productColumns: PRODUCT_COLUMNS,
      selectedProductRowKeys: [],
      productPage: {
        current: 1,
        pageSize: 10
      },
      addProductTargetType: 1,
      addProductTargetOptions: [
        { label: '指定单个商品', value: 1 },
        { label: '指定商品分组', value: 2 }
      ],
      showProductDialog: false,
      selectedQueryParams: {
        proId: '',
        proName: '',
        proCatalog: undefined
      },
      dialogSelectedKeys: [],
      dialogSelectedRows: [],
      showGroupDialog: false,
      selectedQueryGroupParams: {
        groupName: '',
        groupStatus: 1
      },
      groupSelectedKeys: [],
      groupSelectedRows: [],
      groupProductLoading: false,
      showBatchTabDialog: false,
      batchTabName: undefined,
      productSortable: null
    }
  },
  computed: {
    productDialogRowSelection () {
      return {
        selectedRowKeys: this.dialogSelectedKeys,
        onChange: this.onDialogSelectChange
      }
    },
    groupDialogRowSelection () {
      return {
        type: 'radio',
        selectedRowKeys: this.groupSelectedKeys,
        onChange: this.onGroupSelectChange
      }
    },
    groupSelectColumns () {
      return this.getGroupColumns().filter(col => col.dataIndex !== 'action')
    },
    tabNameOptions () {
      const names = (this.value.tabs || [])
        .map(tab => (tab.tabName || '').trim())
        .filter(Boolean)
      return [...new Set(names)].map(name => ({ label: name, value: name }))
    },
    filteredProductTableData () {
      const list = this.value.products || []
      const keyword = (this.productKeyword || '').trim()
      if (!keyword) return list
      return list.filter(item => {
        const id = String(item.proId || '')
        const name = item.productName || ''
        return id.includes(keyword) || name.includes(keyword)
      })
    },
    productPagination () {
      return {
        current: this.productPage.current,
        pageSize: this.productPage.pageSize,
        total: this.filteredProductTableData.length,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50']
      }
    }
  },
  watch: {
    productKeyword () {
      this.productPage.current = 1
    },
    filteredProductTableData () {
      this.$nextTick(() => this.initProductSortable())
    }
  },
  mounted () {
    this.$nextTick(() => this.initProductSortable())
  },
  beforeDestroy () {
    this.destroyProductSortable()
  },
  created () {
    if (!Array.isArray(this.value.tabs) || !this.value.tabs.length) {
      this.$set(this.value, 'tabs', [
        createEmptyTab(''),
        createEmptyTab()
      ])
    } else {
      this.value.tabs.forEach((tab, index) => {
        if (!tab.id) {
          this.$set(tab, 'id', `tab_${Date.now()}_${index}`)
        }
        const tabImage = tab.tabImage || tab.selectedImage || ''
        if (tabImage) {
          this.$set(tab, 'tabImage', tabImage)
          this.$set(tab, 'selectedImage', tab.selectedImage || tabImage)
          if (!Array.isArray(tab.selectedFileList) || !tab.selectedFileList.length) {
            this.$set(tab, 'selectedFileList', [{
              uid: `tab_sel_${index}`,
              name: 'image',
              status: 'done',
              url: tabImage
            }])
          }
        }
        const unChoiceTabImage = tab.unChoiceTabImage || ''
        if (unChoiceTabImage) {
          this.$set(tab, 'unChoiceTabImage', unChoiceTabImage)
          if (!Array.isArray(tab.unselectedFileList) || !tab.unselectedFileList.length) {
            this.$set(tab, 'unselectedFileList', [{
              uid: `tab_unsel_${index}`,
              name: 'image',
              status: 'done',
              url: unChoiceTabImage
            }])
          }
        }
        if (!Array.isArray(tab.selectedFileList)) this.$set(tab, 'selectedFileList', [])
        if (!Array.isArray(tab.unselectedFileList)) this.$set(tab, 'unselectedFileList', [])
      })
    }
    if (!Array.isArray(this.value.products)) {
      this.$set(this.value, 'products', [])
    }
    // 编辑回填：图片类型标题回显上传列表
    if (this.value.focusTitleType === 2 && this.value.focusTitle) {
      this.focusTitleFileList = [{
        uid: 'focus_title',
        name: 'image',
        status: 'done',
        url: this.value.focusTitle
      }]
    }
    if (this.value.focusSubTitleType === 2 && this.value.focusSubTitle) {
      this.focusSubTitleFileList = [{
        uid: 'focus_sub_title',
        name: 'image',
        status: 'done',
        url: this.value.focusSubTitle
      }]
    }
  },
  methods: {
    getUploadFileUrl () {
      const appConfig = this.getAppConfig()
      return appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
    },
    getUploadResponseUrl (file) {
      if (!file) return ''
      if (file.url) return file.url
      const response = file.response
      if (!response) return ''
      if (typeof response === 'string') return response
      if (typeof response.data === 'string') return response.data
      if (response.data && typeof response.data.url === 'string') return response.data.url
      if (typeof response.url === 'string') return response.url
      return ''
    },
    beforeUploadImage (file) {
      const fileName = file.name || ''
      const suffix = fileName.substring(fileName.lastIndexOf('.')).toLowerCase()
      const isAccept = ['.png', '.jpg', '.jpeg'].indexOf(suffix) > -1
      if (!isAccept) {
        this.$message.error('上传文件只能是 png、jpg、jpeg 格式')
        return false
      }
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB')
        return false
      }
      return true
    },
    normalizeFileList (fileList) {
      return fileList.slice(-1).map(file => {
        const url = this.getUploadResponseUrl(file)
        if (url) {
          file.url = url
        }
        return file
      })
    },
    onFocusImageChange (field, info) {
      const fileList = this.normalizeFileList([...info.fileList])
      const url = this.getUploadResponseUrl(fileList[0]) || ''
      if (field === 'focusTitle') {
        this.focusTitleFileList = fileList
        this.value.focusTitle = url
      } else {
        this.focusSubTitleFileList = fileList
        this.value.focusSubTitle = url
      }
      if (info.file.status === 'done') {
        this.$message.success('上传成功')
      } else if (info.file.status === 'error') {
        this.$message.error('上传失败')
      }
    },
    onTabImageChange (tab, type, info) {
      const fileList = this.normalizeFileList([...info.fileList])
      const url = this.getUploadResponseUrl(fileList[0]) || ''
      if (type === 'selected') {
        this.$set(tab, 'selectedFileList', fileList)
        this.$set(tab, 'selectedImage', url)
        this.$set(tab, 'tabImage', url)
      } else {
        this.$set(tab, 'unselectedFileList', fileList)
        this.$set(tab, 'unChoiceTabImage', url)
      }
      if (info.file.status === 'done') {
        this.$message.success('上传成功')
      } else if (info.file.status === 'error') {
        this.$message.error('上传失败')
      }
    },
    onAddTab () {
      this.value.tabs.push(createEmptyTab())
    },
    onRemoveTab (index) {
      if (this.value.tabs.length <= 1) {
        this.$message.warning('至少保留一个Tab标签')
        return
      }
      this.value.tabs.splice(index, 1)
    },
    onAddProduct () {
      if (this.addProductTargetType === 2) {
        this.openGroupDialog()
        return
      }
      this.dialogSelectedKeys = []
      this.dialogSelectedRows = []
      this.selectedQueryParams = {
        proId: '',
        proName: '',
        proCatalog: undefined
      }
      this.showProductDialog = true
    },
    openGroupDialog () {
      this.groupSelectedKeys = []
      this.groupSelectedRows = []
      this.selectedQueryGroupParams = {
        groupName: '',
        groupStatus: 1
      }
      this.showGroupDialog = true
    },
    onDialogSelectChange (selectedRowKeys, selectedRows) {
      this.dialogSelectedKeys = selectedRowKeys
      this.dialogSelectedRows = selectedRows
    },
    onGroupSelectChange (selectedRowKeys, selectedRows) {
      this.groupSelectedKeys = selectedRowKeys
      this.groupSelectedRows = selectedRows
    },
    appendProductsToTable (rows) {
      const existIds = new Set((this.value.products || []).map(item => String(item.proId)))
      const defaultTabName = (this.value.tabs[0] && this.value.tabs[0].tabName) || ''
      const nextProducts = (rows || [])
        .filter(item => item && item.proId != null && !existIds.has(String(item.proId)))
        .map(item => ({
          proId: item.proId,
          productName: item.proName || item.productName || '',
          statusName: item.statusStr || item.proStatusStr || item.statusName || '',
          tabName: defaultTabName
        }))
      if (!nextProducts.length) {
        this.$message.info('所选商品已在列表中或分组下暂无商品')
        return 0
      }
      this.value.products = [...(this.value.products || []), ...nextProducts]
      this.$message.success(`已添加 ${nextProducts.length} 个商品`)
      return nextProducts.length
    },
    onConfirmSelectProducts () {
      if (!this.dialogSelectedRows.length) {
        this.$message.warning('请先选择商品')
        return
      }
      this.appendProductsToTable(this.dialogSelectedRows)
      this.showProductDialog = false
    },
    // 分组详情本身不含商品列表，需再拉分组关联商品
    fetchGroupProducts (groupId) {
      const pageSize = 500
      const loadPage = (pageNum, collected = []) => {
        return this.getHttpServices()
          .getProService()
          .post('proGroup/findProGroupProduct', {
            groupId,
            limitDto: {
              pageNum,
              pageSize
            }
          })
          .then(res => {
            const list = (res && res.data) || []
            const next = collected.concat(list)
            const total = (res && res.totalCount) || 0
            if (list.length && next.length < total && pageNum < 20) {
              return loadPage(pageNum + 1, next)
            }
            return next
          })
      }
      return loadPage(1)
    },
    onConfirmSelectGroup () {
      if (!this.groupSelectedRows.length) {
        this.$message.warning('请先选择商品分组')
        return
      }
      const group = this.groupSelectedRows[0]
      const groupId = group.groupId
      if (groupId == null) {
        this.$message.warning('商品分组无效')
        return
      }
      this.groupProductLoading = true
      // 先校验分组详情，再拉取分组下关联商品回填表格
      this.getHttpServices()
        .getProService()
        .get(`proGroup/getProGroup?groupId=${groupId}`)
        .then(() => this.fetchGroupProducts(groupId))
        .then(list => {
          this.appendProductsToTable(list)
          this.showGroupDialog = false
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '获取分组商品失败')
        })
        .finally(() => {
          this.groupProductLoading = false
        })
    },
    onBatchAction () {
      if (!this.selectedProductRowKeys.length) {
        this.$message.warning('请先勾选要操作的商品')
        return
      }
      if (!this.tabNameOptions.length) {
        this.$message.warning('请先在上方添加Tab标签名')
        return
      }
      this.batchTabName = undefined
      this.showBatchTabDialog = true
    },
    onConfirmBatchTab () {
      if (!this.batchTabName) {
        this.$message.warning('请选择Tab标签')
        return
      }
      const keySet = new Set(this.selectedProductRowKeys.map(id => String(id)))
      this.value.products = (this.value.products || []).map(item => {
        if (!keySet.has(String(item.proId))) return item
        return {
          ...item,
          tabName: this.batchTabName
        }
      })
      this.showBatchTabDialog = false
      this.selectedProductRowKeys = []
      this.$message.success('已批量更新Tab标签')
    },
    onSearchProduct () {
      this.productPage.current = 1
    },
    onProductSelectChange (selectedRowKeys) {
      this.selectedProductRowKeys = selectedRowKeys
    },
    onProductTableChange (pagination) {
      this.productPage = {
        current: pagination.current,
        pageSize: pagination.pageSize
      }
      this.$nextTick(() => this.initProductSortable())
    },
    destroyProductSortable () {
      if (this.productSortable) {
        this.productSortable.destroy()
        this.productSortable = null
      }
    },
    initProductSortable () {
      this.destroyProductSortable()
      const table = this.$refs.productTable
      if (!table || !table.$el) return
      const tbody = table.$el.querySelector('.ant-table-tbody')
      if (!tbody) return
      this.productSortable = Sortable.create(tbody, {
        handle: '.drag-handle',
        animation: 150,
        ghostClass: 'product-drag-ghost',
        onEnd: evt => this.onProductDragEnd(evt)
      })
    },
    onProductDragEnd (evt) {
      const { oldIndex, newIndex } = evt
      if (oldIndex == null || newIndex == null || oldIndex === newIndex) return
      if ((this.productKeyword || '').trim()) {
        this.$message.warning('搜索状态下不支持拖拽排序，请清空搜索后再试')
        this.value.products = [...(this.value.products || [])]
        return
      }
      const pageOffset = (this.productPage.current - 1) * this.productPage.pageSize
      const from = pageOffset + oldIndex
      const to = pageOffset + newIndex
      const list = [...(this.value.products || [])]
      if (from < 0 || to < 0 || from >= list.length || to >= list.length) return
      const [moved] = list.splice(from, 1)
      list.splice(to, 0, moved)
      list.forEach((item, index) => {
        this.$set(item, 'sortNo', index + 1)
      })
      this.value.products = list
    },
    onRemoveProduct (record) {
      this.value.products = this.value.products.filter(item => String(item.proId) !== String(record.proId))
      this.selectedProductRowKeys = this.selectedProductRowKeys.filter(id => String(id) !== String(record.proId))
      this.$message.success('已移除')
    }
  }
}
</script>

<style scoped lang="less">
.focus-module {
  flex: 1;
  min-width: 0;
  max-height: calc(100vh - 260px);
  overflow-x: hidden;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 16px;
  display: flex;
  flex-direction: column;
}

.form-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
}

.form-label {
  width: 100px;
  line-height: 32px;
  text-align: right;
  color: #333;
  flex-shrink: 0;
}

.form-content {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
}

.type-select {
  width: 100px;
  flex-shrink: 0;
}

.title-input {
  width: 320px;
}

.upload-wrap {
  .upload-tip {
    margin-top: 4px;
    color: #999;
    font-size: 12px;
  }
}

.section-title {
  margin: 8px 0 12px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.style-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}

.style-item {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 4px;
  // background: #0f3d2e;

  &.active {
    border-color: #1890ff;
  }
}

.style-preview-img {
  display: block;
  width: 100%;
  height: auto;
  vertical-align: top;
}

.tab-list {
  margin-bottom: 20px;
}

.tab-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.tab-name-input {
  width: 180px;
}

.tab-remove {
  color: #ff4d4f;
  font-size: 16px;
  cursor: pointer;
}

.tab-add-btn {
  width: 180px;
}

.product-bind-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;

  .section-title {
    margin: 0;
  }

  .drag-tip {
    margin-left: 8px;
    font-size: 12px;
    font-weight: 400;
    color: #999;
  }
}

.drag-handle {
  color: #999;
  cursor: move;
  font-size: 16px;
}

/deep/ .product-drag-ghost {
  opacity: 0.6;
  background: #e6f7ff;
}

.product-bind-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.add-target-select {
  width: 140px;
}

.product-select-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
}

.batch-tab-form {
  display: flex;
  align-items: center;
}

.batch-tab-label {
  width: 80px;
  text-align: right;
  margin-right: 8px;
}

.batch-tab-tip {
  margin-top: 12px;
  margin-left: 88px;
  color: #999;
  font-size: 12px;
}
</style>
